import { CardUpdateRequest, CardUpdateResponse } from "./types";
import { BASE_URL } from '../../config';
import { getApiKey, getFlywireCode, uuidv4 } from "services/common";
import * as Sentry from '@sentry/react';

export const updateCard = async (
  request: CardUpdateRequest,
  country: string,
  hash: string,
  region: string,
  provider: string = 'FLY'
  ): Promise<CardUpdateResponse> => {
  const dataSentry:any = { ...request };
  delete dataSentry.token;
  try {
    const response = await fetch(`${BASE_URL}/api-payments/v1/subscriptions/card/${hash}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        'x-api-key': getApiKey(region),//TODO: Corregir
        'X-User': 'web',
        'X-Recipient-ID': getFlywireCode(country, region),
        'X-Request-ID': uuidv4(),
        'X-Payment-Gateway': provider
      },
      body: JSON.stringify(request)
    });

    if (!response.ok) {
      const errorData = await response.json();
      Sentry.logger.error('cardService[updateCard] error', { session: hash, request: dataSentry, status: response.status, message: await response.text() });
      return {
        success: false,
        error: {
          message: `Failed to update card: ${response.statusText}`,
          code: `${response.status}`,
          status: response.status,
          details: errorData,
        }
      };
    }
    Sentry.logger.info('cardService[updateCard]', { session: hash, request: dataSentry, response: { message: 'ok' } });
    return {
      success: true,
    };
    //return await response.json();
  } catch (error) {
    Sentry.logger.error('cardService[updateCard] unexpected error', { session: hash, request: dataSentry, error: error });
    return {
      success: false,
      error: {
        message: `Unexpected error: ${error}`,
        code: 'NETWORK_ERROR'
      }
    };
  }
};